const SECRET_TOKEN = 'app_token';
const LAST_BUILDING_ID = 'app_last_building_id';
const DEVICE_ID = 'app_device_id';
const MOBILE_APP_BANNER_DISMISSED_AT = 'app_mobile_app_banner_dismissed_at';

export const getToken = (): string | null => {
  return window.localStorage.getItem(SECRET_TOKEN);
};

export const setToken = (token: string): void => {
  window.localStorage.setItem(SECRET_TOKEN, token);
};

export const deleteToken = (): void => {
  window.localStorage.removeItem(SECRET_TOKEN);
};

export const getLastBuildingId = (): string | null => {
  return window.localStorage.getItem(LAST_BUILDING_ID);
};

export const setLastBuildingId = (buildingId: string): void => {
  window.localStorage.setItem(LAST_BUILDING_ID, buildingId);
};

export const deleteLastBuildingId = (): void => {
  window.localStorage.removeItem(LAST_BUILDING_ID);
};

// Stabilní anonymní identifikátor prohlížeče pro auditní stopu hlasování (hlavička X-Device-Id).
// Záměrně se nemaže při odhlášení.
export const getDeviceId = (): string => {
  let deviceId = window.localStorage.getItem(DEVICE_ID);
  if (!deviceId) {
    deviceId =
      typeof crypto !== 'undefined' && crypto.randomUUID
        ? crypto.randomUUID()
        : `${Date.now().toString(36)}-${Math.random().toString(36).slice(2, 12)}`;
    window.localStorage.setItem(DEVICE_ID, deviceId);
  }
  return deviceId;
};

// Zavření lišty propagující mobilní aplikaci (timestamp v ms). Čtení i zápis jsou chráněné —
// v privátním režimu / při zakázaném úložišti nesmí lišta shodit aplikaci.
export const getMobileAppBannerDismissedAt = (): number | null => {
  try {
    const value = window.localStorage.getItem(MOBILE_APP_BANNER_DISMISSED_AT);
    const timestamp = value ? Number(value) : NaN;
    return Number.isFinite(timestamp) ? timestamp : null;
  } catch {
    return null;
  }
};

export const setMobileAppBannerDismissedAt = (timestamp: number): void => {
  try {
    window.localStorage.setItem(MOBILE_APP_BANNER_DISMISSED_AT, String(timestamp));
  } catch {
    // úložiště nedostupné — lišta se zavře jen pro aktuální načtení stránky
  }
};

export default {
  getToken,
  setToken,
  deleteToken,
  getLastBuildingId,
  setLastBuildingId,
  deleteLastBuildingId,
  getDeviceId,
  getMobileAppBannerDismissedAt,
  setMobileAppBannerDismissedAt,
};
